import React from "react";
import AutoIncrementEditor from "./editors/AutoIncrementEditor";
import ResponseBasedEditor from "./editors/ResponseBasedEditor";
import CustomPaginationEditor from "./editors/CustomPaginationEditor";
import { PaginationType } from "../../../../../../../common/interfaces/flow/action/WebRequestAction";

const PaginationEditor = ({ action, paginationType: paginationTypeOverride, variableName }) => {
  const paginationType = paginationTypeOverride ?? action?.pagination?.type;

  if (!action || !paginationType) {
    return null;
  }

  return (
    <>
      {paginationType === PaginationType.AUTO_INCREMENT && <AutoIncrementEditor action={action} variableName={variableName} />}
      {paginationType === PaginationType.RESPONSE_BASED && <ResponseBasedEditor action={action} />}
      {paginationType === PaginationType.CUSTOM && <CustomPaginationEditor action={action} />}
    </>
  );
};

export default PaginationEditor;
